import styled, {css} from 'styled-components';

interface ItemProps {
  readonly top?: boolean;
  readonly color?: string;
}

export const LeadArticle = styled.article`
  box-shadow: 0 0 10px 3px rgba(93, 110, 129, 0.09);
  border: 1px solid #e6e7e9;
  margin-bottom: 40px;
  border-radius: 6px;
  border-top: none;
  max-width: 652px;
  max-height: 85vh;
  overflow-y: scroll;
  height: fit-content;
`;

export const LeadHeader = styled.div`
  background-color: var(--BackgroundGrey);
  border-top: 1px solid #e6e7e9;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  align-items: center;
  padding: 27px 33px 14px 33px;
  position: sticky;
  display: flex;
  top: 0px;

  & span:last-of-type {
    color: var(--DarkGray);
    font-size: 18px;
    font-weight: 700;
    margin-left: 8px;
  }
`;

export const LeadItemNumber = styled.div<ItemProps>`
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
  background-color: #acb1c0;
  justify-content: center;
  border: none !important;
  padding: 0 !important;
  align-items: center;
  display: flex;
  height: 54px;
  min-width: 72px;
  max-width: 72px;

  & span {
    color: var(--BackgroundColor);
    font-weight: 600;
    font-size: 30px;
  }
  background: ${props => props.color};
`;

export const LeadItem = styled.div`
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  margin: 10px 0;
  display: flex;
  cursor: pointer;
  & img {
    object-fit: cover;
    height: 54px;
    width: 54px;
  }

  & > div {
    border: 1px solid #e6e8ea;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-left: none;
    min-height: 52px;
    padding: 0 10px;
    display: flex;
  }

  & > div:nth-child(3) {
    color: var(--DarkGray);
    font-weight: 500;
    font-size: 14px;
    min-width: 157px;
    max-width: 157px;
  }
  & > div:nth-child(4) {
    min-width: 174px;
    max-width: 174px;
  }

  & > div:nth-child(3) span:first-of-type {
    color: var(--DarkGray);
    font-weight: 500;
    font-size: 14px;
    max-width: 100%;
    text-overflow: ellipsis;

    white-space: nowrap;
    overflow: hidden;
  }

  & > div:nth-child(3) span:last-of-type {
    line-height: 14.77px;
    font-weight: 400;
    font-size: 10px;
  }

  & > div:nth-child(4) div:first-of-type {
    justify-content: center;
    color: var(--DarkGray);
    align-items: center;
    font-size: 14px;
    display: flex;
  }

  & > div:nth-child(4) div:first-of-type span:last-of-type {
    margin-left: 4px;
    font-weight: 500;
  }

  & > div:nth-child(4) > span:last-of-type {
    font-size: 12px;
  }
`;

export const LeadItemWrap = styled.div<ItemProps>`
  ${props => {
    if (props.top) {
      return css`
        background-color: var(--BackgroundGrey);
        border-bottom: 1px solid #e6e8ea;
        padding: 0 30px 10px 30px;
        position: sticky;
        top: 64px;

        & > div {
          background-color: var(--BackgroundColor);
        }
      `;
    } else {
      return css`
        background-color: var(--BackgroundColor);
        padding: 10px 30px 20px 30px;
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
      `;
    }
  }}
`;

export const LeadItemBase = styled.div`
  background-color: var(--DarkGray);
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
  justify-content: center;
  padding: 0 !important;
  align-items: center;
  display: flex;
  height: 54px;
  min-width: 80px;

  & span {
    color: var(--BackgroundColor);
    font-weight: 600;
    font-size: 17px;
  }
`;
